<template>
  <div class="register">
    <backHeader back-addr="/login"></backHeader>
    <!-- <mt-header title="注册" style="background:#26a2ff;color:#fff;">
      <router-link to="/login" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header> -->
    <div class="formItem">
      <mt-field label="用户名" placeholder="用户名" v-model="register_username"></mt-field>
        <mt-field label="姓名" placeholder="姓名" v-model="register_name"></mt-field>
      <mt-field label="手机号"  v-model="register_phone" :state="phonStat" placeholder="手机号"></mt-field>
      <!-- <p><mt-field label="" placeholder="验证码" :state="telCodeStat" type="telCode" v-model="telCode"></mt-field>
        <span class="sendCode" @click="sendPhoCode" >发送验证码</span>
      </p> -->
      <mt-field label="密码" placeholder="6-16位数字与字母" :state="pasStat" type="password" v-model="register_password1"></mt-field>
      <mt-field label="确认密码" placeholder="确认密码" :state="pasStat1" type="password" v-model="register_password2"></mt-field>
      <div class="subBut" @click="register">完成</div>
      <div class="more">
        <router-link :to="{'path':'/login'}" class="forgetPass">已有账号去登录？去 <i>登陆</i></router-link>
      </div>
    </div>
  </div>
</template>
<script>
import backHeader from "./../components/back-header.vue";
import logApi from "../api/users";
import { MessageBox,Toast } from "mint-ui";
import axios from "axios";
import Qs from "qs";
import Addr from "./../utils/getAPI";
import store from "@/store/index";

export default {
  name: "register",
  data() {
    return {
      phonStat: "",
      pasStat: "",
      pasStat1: "",
      register_username: "",
      register_name: "",
      register_phone: "",
      register_password1: "",
      register_password2: ""
    };
  },
  methods: {
    // 提交注册
    register() {
      if (this.register_username == "") {
        Toast({
          message: "用户名不得为空！",
          position: "bottom",
          duration: 800
        });
        return;
      }
      if (this.register_name == "") {
        Toast({
          message: "姓名不得为空！",
          position: "bottom",
          duration: 800
        });
        return;
      }
      if (this.register_phone == "") {
        Toast({
          message: "手机号不得为空！",
          position: "bottom",
          duration: 800
        });
        return;
      }
      if (this.register_password1 == "" || this.register_password2 == "") {
        Toast({
          message: "密码不得为空！",
          position: "bottom",
          duration: 800
        });
        return;
      }
      if (this.register_password1 != this.register_password2) {
        Toast({
          message: "两次输入的密码不一致！",
          position: "bottom",
          duration: 800
        });
        return;
      }

      axios
        .post(
          Addr.getGoNewAPIPrefix() + "user/register",
          Qs.stringify({
            username: this.register_username,
            name: this.register_name,
            phone: this.register_phone,
            password: this.register_password1
          })
        )
        .then(res => {
          if (res.data.returnCode == 107) {
            console.log("register success");
            console.log(res.data.returnData);
            Toast({
              message: "注册成功！",
              position: "bottom",
              duration: 800
            });

            this.$store.commit("updateUserId", res.data.returnData);
            this.$store.commit("updateUserNumber", "");
            this.$store.commit("updateUserName", this.register_username);
            this.$store.commit("updateRole", "");
            this.$store.commit("updateIsLogin", true);
            this.$store.commit("updateLoginTime", Date.parse(new Date()));

            this.$router.push({
              path: "/person"
            });
          } else if (res.data.returnCode == 105) {
            Toast({
              message: "用户名已经存在！",
              position: "bottom",
              duration: 800
            });
          } else if (res.data.returnCode == 108) {
            Toast({
              message: "生成uuid失败！",
              position: "bottom",
              duration: 800
            });
          } else if (res.data.returnCode == 109) {
            Toast({
              message: "添加appUser失败！",
              position: "bottom",
              duration: 800
            });
          }
        })
        .catch(err => {
          Toast({
            message: "注册出现异常！",
            position: "bottom",
            duration: 800
          });
          console.log("register failed");
          console.log(err);
        });
    }
  },
  watch: {
    register_phone(val, oldval) {
      if (/^1[34578]\d{9}$/.test(val)) {
        this.phonStat = "success";
      } else {
        this.phonStat = "warning";
      }
    },
    register_password1(val, oldval) {
      if (/^[A-Za-z0-9]{6,18}$/.test(val)) {
        this.pasStat = "success";
      } else {
        this.pasStat = "warning";
      }
    },
    register_password2(val, oldval) {
      if (/^[A-Za-z0-9]{6,18}$/.test(val)) {
        this.pasStat1 = "success";
      } else {
        this.pasStat1 = "warning";
      }
    }
  },
  mounted: function() {},
  components: {backHeader}
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.register {
  .formItem {
    font-size: 18px;
    margin: 0 30px;
    p {
      position: relative;
    }
    .mint-cell {
      background: transparent;
    }
    .mint-cell-wrapper {
      background: transparent;
      padding: 0;
      border-bottom: solid 1px $cl14;
    }
    .subBut {
      background: $cl0;
      color: $cl1;
      text-align: center;
      line-height: 40px;
      margin: 20px 0;
    }
    .more {
      position: relative;
      width: 100%;
      left: 0px;
      top: 40px;
      text-align: center;
      i {
        color: $cl0;
      }
      .forgetPass {
        color: $cl9;
      }
    }
    .sendCode {
      position: absolute;
      right: 0px;
      top: 6px;
      display: inline-block;
      font-size: 14px;
      color: $cl0;
      border: solid 1px $cl0;
      padding: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-my/register.vue